import AnswerOption, { AnswerOptionProps } from './AnswerOption';

export type { AnswerOptionProps };
export default AnswerOption;
